import { Component, Inject, LOCALE_ID } from '@angular/core';
import {
  ModalController,
  ToastController,
  AlertController,
} from '@ionic/angular';

import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { DiversityService } from '../shared/diversity.service';

@Component({
  selector: 'app-diversity-check',
  templateUrl: './diversity-check.modal.html',
  styleUrls: ['./diversity-check.modal.scss'],
})
export class DiversityCheckModal extends BaseClass {
  accepted: boolean = false;
  loading: boolean;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    public modalController: ModalController,
    public alertController: AlertController,
    private _diversytiCheckService: DiversityService,
    @Inject(LOCALE_ID) private locale: string
  ) {
    super(_toastController, _translationService);
  }

  public dismiss() {
    this.modalController.dismiss(this.accepted);
  }

  public accept() {
    this.loading = true;
    this._diversytiCheckService.acceptDiversityCheck().subscribe(
      () => {
        this.accepted = true;
        this.modalController.dismiss(this.accepted);
      },
      () => this.notifyError('diversityCheck.AcceptError'),
      () => (this.loading = false)
    );
  }
}
